module.exports = __webpack_public_path__ + "img/ski_cos9.17f76fca.png";